var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBsLogoJtbc4Wh({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 15,
    viewBox: "0 0 40 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\xEA\xB7\xB8\xEB\xA3\xB9 144"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\xEA\xB7\xB8\xEB\xA3\xB9 143"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\xED\x8C\xA8\xEC\x8A\xA4 282",
    d: "M5.77145 8.87737C5.75221 10.4769 6.34918 12.019 7.43148 13.1656C8.51378 14.3122 9.99309 14.9697 11.5451 14.994V11.4987C10.8797 11.4882 10.2456 11.2061 9.78193 10.7142C9.31827 10.2223 9.06298 9.56083 9.07211 8.87512V6.47419H11.5451V2.97961H9.07211V0L5.7729 2.97961L5.77145 8.87737Z",
    fill: "url(#paint0_linear_255_149)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\xED\x8C\xA8\xEC\x8A\xA4 283",
    d: "M27.6714 11.1199C27.2874 11.3693 26.8423 11.5006 26.3884 11.4984C25.7321 11.4704 25.1116 11.182 24.6568 10.6934C24.2021 10.2049 23.9481 9.5541 23.9481 8.8771C23.9481 8.20009 24.2021 7.54929 24.6568 7.06076C25.1116 6.57224 25.7321 6.28381 26.3884 6.25579C26.8425 6.25385 27.2877 6.38571 27.6714 6.63583V2.91263C27.2508 2.81203 26.8203 2.76172 26.3884 2.76271C24.8445 2.80932 23.379 3.47414 22.303 4.61608C21.2269 5.75802 20.625 7.28717 20.625 8.87897C20.625 10.4708 21.2269 11.9999 22.303 13.1419C23.379 14.2838 24.8445 14.9486 26.3884 14.9952C26.8203 14.9962 27.2508 14.9459 27.6714 14.8453V11.1199Z",
    fill: "url(#paint1_linear_255_149)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\xED\x8C\xA8\xEC\x8A\xA4 284",
    d: "M20.6165 8.87737C20.6131 7.51221 21.0478 6.18421 21.853 5.10019C21.3225 4.37674 20.637 3.78934 19.85 3.3838C19.063 2.97827 18.1957 2.76555 17.3159 2.76223C16.4585 2.761 15.6123 2.96311 14.8429 3.35291V0H11.5459V8.87512C11.5264 10.474 12.1228 12.0157 13.2044 13.1623C14.286 14.3088 15.7644 14.9667 17.3159 14.9918C18.195 14.988 19.0615 14.7753 19.8478 14.37C20.6341 13.9648 21.3191 13.378 21.8494 12.6553C21.0456 11.5704 20.6122 10.2423 20.6165 8.87737ZM17.3159 11.4987C16.8095 11.5136 16.3104 11.3725 15.8823 11.0934C15.4542 10.8144 15.1166 10.41 14.9127 9.93214C14.7089 9.45425 14.6479 8.92455 14.7378 8.41079C14.8277 7.89703 15.0642 7.42258 15.4171 7.04813C15.7701 6.67369 16.2234 6.41627 16.7191 6.30881C17.2148 6.20136 17.7303 6.24875 18.1998 6.44493C18.6692 6.6411 19.0711 6.97714 19.3542 7.41006C19.6373 7.84297 19.7886 8.35308 19.7888 8.87512C19.7975 9.56072 19.5421 10.2219 19.0786 10.7137C18.615 11.2055 17.9811 11.4878 17.3159 11.4987Z",
    fill: "url(#paint2_linear_255_149)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\xED\x8C\xA8\xEC\x8A\xA4 285",
    d: "M2.47295 8.87725C2.48209 9.56297 2.2268 10.2244 1.76314 10.7163C1.29948 11.2082 0.66535 11.4903 0 11.5008V14.9916C1.55185 14.9673 3.031 14.3098 4.11307 13.1631C5.19514 12.0165 5.79179 10.4744 5.77216 8.875V2.97949H2.47295V8.87725Z",
    fill: "url(#paint3_linear_255_149)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "\xED\x8C\xA8\xEC\x8A\xA4 286",
    d: "M37.9721 10.2868V1.28271H33.8896L29.1299 12.8264H35.1995V15.0002H37.9721V12.8264H40V10.2868H37.9721ZM35.1995 10.2868H33.1513L35.2017 5.314L35.1995 10.2868Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_255_149",
    x1: 5.771,
    y1: 7.497,
    x2: 11.5451,
    y2: 7.497,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "white",
    stopOpacity: 0.851
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_255_149",
    x1: 20.625,
    y1: 8.87897,
    x2: 27.6714,
    y2: 8.87897,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "white",
    stopOpacity: 0.851
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_255_149",
    x1: 11.5454,
    y1: 7.49588,
    x2: 21.853,
    y2: 7.49588,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "white",
    stopOpacity: 0.851
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_255_149",
    x1: 0,
    y1: 8.98556,
    x2: 5.77263,
    y2: 8.98556,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "white",
    stopOpacity: 0.851
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBsLogoJtbc4Wh);
export default __webpack_public_path__ + "static/media/BS_logo_jtbc4_wh.df86e4aa77df4c4a456cc6fd3b6b70b2.svg";
export { ForwardRef as ReactComponent };